import { Segmented } from 'antd';
import React from 'react';
import classes from './AnalyticsReport.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo, faCircleQuestion, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'store/hook';
import { groupSections } from './parseToJson';

const AnalyticsReport = () => {
  const [content, setContent] = React.useState<any>(null);
  const [currentSegment, setCurrentSegment] = React.useState('main');

  const divRef = React.useRef<HTMLDivElement | null>(null);
  
  const { analysisData } = useAppSelector((state) => state.aiFunctions);
  
  const { t } = useTranslation();
  
  const segmentOptions = [
    { value: 'main', key: 'main', label: t('Documents.details.analysisTab.ready.main'), icon: <FontAwesomeIcon className={classes.faIcon} icon={faCircleInfo} /> },
    { value: 'sum', key: 'sum', label: t('Documents.details.analysisTab.ready.sum'), icon: <FontAwesomeIcon className={classes.faIcon} icon={faCircleQuestion} /> },
    { value: 'risks', key: 'risks', label: t('Documents.details.analysisTab.ready.risks'), icon: <FontAwesomeIcon className={classes.faIcon} icon={faTriangleExclamation} /> },
  ];  
  
  React.useEffect(() => {
    const reportData = analysisData?.file;
    
    if (reportData) {
      const reportSections = reportData.split(/(?=^(?:#{1,2}\s*(?:\d+\.)?|\d+\.))/gm);    
      const groupedContent = groupSections(reportSections);
      setContent(groupedContent);
    }
  },[analysisData]);

  const normalizeText = (input: string): string => {
    return input
      .replace(/\u00A0/g, " ")        // NBSP → обычный пробел
      .replace(/\t+/g, " ")           // табы → пробел
      .replace(/ {2,}/g, " ")         // 2+ пробелов → один
      // .replace(/\n\s+/g, "\n")        // убираем пробелы после переноса строки
      .replace(/^\s+|\s+$/g, "");     // trim всего текста
  };

  const replaceBoldMarkdown = (input: string): string => {
    const normalized = normalizeText(input);

    return normalized?.replace(/\*\*([\s\S]+?)\*\*/g, (_m, inner) => {
      return `<b>${inner}</b>`;
    });
  };

  React.useEffect(() => {
    const div = divRef.current?.querySelector(`.${classes.textContent}`);
    div?.scrollTo({ top: 0, behavior: 'smooth' });      
  },[currentSegment, divRef.current]);

  const cases = {
    main: (
      <div className={classes.holder}>
        <div className={classes.titleSubAnalysis}>{t('Documents.details.analysisTab.ready.mainTitle')}</div>
        <div className={classes.textContent}>

          {content?.g1?.map((data: any, i: number) => (
            <div key={`g1_${i}`}>
              <div className={classes.subsubtitle}>{data?.title}</div>
              <div
                className={classes.subContentBody}
                dangerouslySetInnerHTML={{
                  __html: replaceBoldMarkdown(data?.body)
                }}
              />
            </div>
          ))}
          
        </div>
      </div>
    ),
    sum: (
      <div className={classes.holder}>
        <div className={classes.titleSubAnalysis}>{t('Documents.details.analysisTab.ready.sumTitle')}</div>
        <div className={classes.textContent}>
          
          {content?.g2?.map((data: any, i: number) => (
            <div key={`g2_${i}`}>
              <div className={classes.subsubtitle}>{data?.title}</div>
              <div
                className={classes.subContentBody}
                dangerouslySetInnerHTML={{
                  __html: replaceBoldMarkdown(data?.body)
                }}
              />
            </div>
          ))}
          
        </div>
      </div>
    ),
    risks: (
      <div className={classes.holder}>
        <div className={classes.titleSubAnalysis}>{t('Documents.details.analysisTab.ready.risksTitle')}</div>
        <div className={classes.textContent}>
          
          {content?.g3?.map((data: any, i: number) => (
            <div key={`g3_${i}`}>
              <div className={classes.subsubtitle}>{data?.title}</div>
              <div
                className={classes.subContentBody}
                dangerouslySetInnerHTML={{
                  __html: replaceBoldMarkdown(data?.body)
                }}
              />
            </div>
          ))}

        </div>
      </div>
    ),
  };

  return (
    <div className={classes.reportWrap}>
      <div className={classes.segmentWrap}>
        <Segmented
          className={classes.segment}
          options={segmentOptions}
          block
          value={currentSegment}
          onChange={(value) => setCurrentSegment(value)}
        />
      </div>
      <div ref={divRef} className={classes.reportContent}>{cases[String(currentSegment || 'main') as keyof typeof cases]}</div>
    </div>
  );
}

export default AnalyticsReport;
